// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-selected[data-v-2dc8c218]{font-weight:700}", ""]);
// Exports
module.exports = exports;
